/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { detectIncognito } from 'detectincognitojs';

const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:6201/', withCredentials: true });

axiosServices.interceptors.request.use(
    async (config) => {
        const accessToken = localStorage.getItem('serviceToken');
        const publicIp = localStorage.getItem('public-ip');

        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }

        // for private browsing
        await detectIncognito().then((result) => {
            config.headers['robot-browser'] = result.browserName;
            config.headers['robot-browser-private'] = result.isPrivate ? 'private' : 'normal';
        });

        if (publicIp) {
            config.headers['public-ip'] = publicIp;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
